import { render, staticRenderFns } from "./BankAccountForm.vue?vue&type=template&id=2ee491df"
import script from "./BankAccountForm.vue?vue&type=script&lang=js"
export * from "./BankAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports